import api from '../../utils/api';

const API_BASE_URL = "/admin/ADPMenu"; // Adjust to match your backend API

const ADPMenuService = {
  async findAll(facilityCode: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`, { params: { facilityCode } });
    return response.data;
  },

  async getItemById(objectId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${objectId}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(objectId: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${objectId}`, item);
    return response.data;
  },

  async delete(objectId: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${objectId}`);
    return response.data;
  },

  async getADPMenuTree(objectId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-menu-tree/${objectId}`);
    return response.data;
  },

  async getADPMenuTreeAccess(objectId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-menu-tree-access/${objectId}`);
    return response.data;
  },

  async getDropdownByObjectType(objectType: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-dropdown-by-object-type`, { params: { objectType } });
    return response.data;
  },

  async deleteMenuTree(objectId: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete-menu-tree/${objectId}`);
    return response.data;
  },
};



export default ADPMenuService;